(() => {
  const initTabs = (root) => {
    if (!root || root.dataset.vigoTabsReady === 'true') return;
    root.dataset.vigoTabsReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[role="tab"][data-vigo-tab]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"][data-vigo-tab-panel]'));
    if (!tabs.length || !panels.length) return;

    const activate = (tab, moveFocus = false) => {
      const key = tab.dataset.vigoTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        const active = panel.dataset.vigoTabPanel === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (moveFocus) tab.focus({ preventScroll: true });
      tab.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let targetIndex = null;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = tabs.length - 1;
        if (targetIndex === null) return;
        event.preventDefault();
        activate(tabs[targetIndex], true);
      });
    });

    const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    activate(selected);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll?.('[data-vigo-product-tabs]').forEach(initTabs);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
